module.exports = __webpack_public_path__ + "static/media/viajeAsignadoImg.bf1c33cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/viajeAsignadoImg.png
// module id = 2022
// module chunks = 0